export default __webpack_public_path__ + "static/LargestUSCoBadge-d03c8afb44ab01a4fe19fd2fc8eee134.webp";